<template
  ><!-- 弹框 -->
  <el-dialog
    :visible.sync="visible"
    class="pending-order-dialog"
    width="820px"
    center
    :append-to-body="true"
    :before-close="setOrderFlag"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="pending-order-content">
      <div class="header">
        <i
          class="el-icon-close"
          style="font-size: 20px;cursor: pointer;"
          @click="setOrderFlag"
        ></i>
        <div class="flex-row-start-center title">
          <i class="el-icon-warning"></i>
          <span>
            以下售后单即将超过处理时效，请尽快处理
          </span>
        </div>
        <asOrder ref="asRef" @setOrderFlag="setOrderFlag" />
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { queryPendingMsg } from "@/models/aftersaleModel";
import asOrder from "../pendingOrder/asOrder.vue";
import { mapGetters } from "vuex";
let timerStrong = null;
export default {
  name: "pendingAsOrderDialog",
  data() {
    return {
      visible: false
    };
  },
  components: {
    asOrder
  },
  computed: {
    ...mapGetters(["pendingAsOrderFlag"])
  },
  watch: {
    pendingAsOrderFlag: {
      handler: function(newVal) {
        if (!newVal) {
          this.visible = false;
        }
      },
      immediate: true
    }
  },
  mounted() {
    timerStrong = setInterval(() => {
      this.$store.dispatch("app/isQueryPendingAsOrder", true);
      // 10分钟调一次接口(page=1,size=10)，有数据时，visible= true

      this.getPendingMsg();
    }, 600000);
    // }, 20000);
  },
  beforeDestroy() {
    window.clearInterval(timerStrong);
    timerStrong = null;
  },
  methods: {
    //获取未处理售后消息列表
    async getPendingMsg() {
      const shop_id = Number(localStorage.getItem("shop_id"));
      try {
        const res = await queryPendingMsg({
          shop_id,
          page: 1,
          page_size: 10,
          type: 2 //2-售后，3-拒收
        });
        this.setAsList(res);
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    setAsList(res) {
      if (res.list && res.list.length > 0) {
        this.visible = true;
        this.$nextTick(() => {
          this.$refs.asRef.setList(res);
        });
      }
    },
    setOrderFlag() {
      this.visible = false;

      this.$refs.asRef.clearTimer();
    }
  }
};
</script>
<style lang="scss">
.pending-order-dialog {
  .el-dialog.el-dialog--center {
    border-radius: 10px;
  }

  .el-dialog__header {
    display: none !important;
  }

  .el-dialog__body {
    color: inherit;
  }

  .header div {
    font-weight: normal;
  }
  .header .el-icon-close {
    position: absolute;
    top: 16px;
    right: 20px;
    z-index: 99;
  }
  .header {
    .title {
      font-size: 14px;
      margin-bottom: 12px;
      padding-left: 16px;
      border-bottom: 1px solid #e9e9e9;
      padding-bottom: 8px;
    }
    .el-icon-warning {
      color: #faad14;
      font-size: 20px;
      margin-right: 8px;
    }
  }
  .el-dialog--center .el-dialog__body {
    // padding: 16px 16px 12px;
    padding: 16px 0 12px;
  }
  .el-dialog .el-pagination__jump .el-input {
    width: 50px !important;
  }
  .el-tabs__header {
    padding: 0 16px;
  }
  .order-tips {
    position: absolute;
    bottom: 30px;
    color: red;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pendingAsOrder/index.vue